import { Icon } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import Currency from 'components/currency';
import { useCartContext } from 'state/cart';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { primitive } from 'styles/constants/primitives';

import { Container, Header, LineItem, TextDetails, Title, TitleContainer } from './styled';

const PriceMismatchInternalOnly = () => {
  const enablePriceMismatch = useFlag(LaunchDarklyFlag.ENABLE_PRICE_MISMATCH_INTERNAL_ONLY);
  const { formatMessage } = useIntl();
  const { requestedAmountCents, serverOrder } = useCartContext();
  const subTotalCents = serverOrder?.cart.subTotalCents;

  if (!subTotalCents) {
    return null;
  }

  const priceMismatch = subTotalCents !== requestedAmountCents;

  return enablePriceMismatch && priceMismatch ? (
    <Container>
      <Header>{formatMessage({ id: 'forInternalUseOnly' })}</Header>
      <TitleContainer>
        <Icon variant="warning" color={primitive.$white} aria-hidden size="4" />
        <Title>{formatMessage({ id: 'priceMismatchDetected' })}</Title>
      </TitleContainer>
      <LineItem>
        <TextDetails>{formatMessage({ id: 'requestedAmount' })}</TextDetails>
        <Currency textProps={{ color: primitive.$white }} amount={requestedAmountCents} />
      </LineItem>
      <LineItem>
        <TextDetails>{formatMessage({ id: 'subtotal' })}</TextDetails>
        <Currency textProps={{ color: primitive.$white }} amount={subTotalCents} />
      </LineItem>
    </Container>
  ) : null;
};
export default PriceMismatchInternalOnly;
